"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _classnames = _interopRequireDefault(require("classnames"));
var _hover = require("../../hooks/hover");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ThreadItemAvatar = function ThreadItemAvatar(_ref) {
  var quickAction = _ref.quickAction,
    children = _ref.children;
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  var showQuickAction = hovered && !(0, _isNil["default"])(quickAction);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, targetProps, {
    className: "relative flex items-center w-full h-full"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute left-0 top-0', {
      'z-10': showQuickAction,
      invisible: !showQuickAction
    })
  }, quickAction), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute left-0 top-0', {
      'z-10': !showQuickAction,
      invisible: showQuickAction
    })
  }, children));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ThreadItemAvatar);
//# sourceMappingURL=index.js.map